<template>
<div>
<section class="section">
<div class="container">

	<h1 class="title">
		Studios
		<a @click="$router.push('/studios/add')">
			<span class="icon">
				<i class="fas fa-plus-circle"></i>
			</span>
		</a>
	</h1>

	<div class="columns is-multiline">
		<div class="column is-one-third" v-for="studio in studios" :key="studio.uid">
			<div class="box">
				<h3 class="title is-5">
					{{ studio.name }}
				</h3>
				<div>
					{{ studio.address.street }} {{ studio.address.suite }}<br>
					{{ studio.address.city }}, {{ studio.address.state }} {{ studio.address.zip }}<br>
				</div>
				<br>
				<div class="field is-grouped is-grouped-right">
					<div class="control">
						<button @click="handleDelete(studio)" class="button is-danger is-outlined">
							<span class="icon">
								<i class="fas fa-trash-alt"></i>
							</span>
							<span>
								Delete
							</span>
						</button>
					</div>
					<div class="control">
						<button @click="$router.push('/studios/' + studio.uid)" class="button">
							<span class="icon">
								<i class="fas fa-edit"></i>
							</span>
							<span>
								Edit
							</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
</section>
<alert-modal ref="alertModal" />
</div>
</template>

<script>
import AlertModal from '@/components/AlertModal'

import {
	firestore as db,
	collections
} from '@/firebase'

import sortBy from 'lodash/sortBy'

export default {
	data: function () {
		return {
		}
	},
	methods: {
		handleDelete: function (studio) {
			this.$refs.alertModal.show({
				title: `Confirm Delete ${studio.name}?`,
				message: 'Are you sure you want to delete this studio? It cannot be undone and any classes still referencing this studio may become broken.',
				confirm: 'Yes'
			})
			.then(() => {
				db.collection(collections.Studios).doc(studio.uid).delete()
			})
			.then(() => {
				this.$refs.alertModal.close()
			})

			
		}
	},
	computed: {
		studios: function () {
			return sortBy(this.$store.getters.studios, 'name')
		}
	},
	components: {
		AlertModal
	}
}
</script>

<style scoped>

</style>